var setSpecies = require('../internals/set-species');

// `Array[@@species]` getter
// https://tc39.github.io/ecma262/#sec-get-array-@@species
setSpecies('Array');



//////////////////
// WEBPACK FOOTER
// ../node_modules/core-js/modules/es.array.species.js
// module id = 537
// module chunks = 20 21 22 23 24 25 26 27 28 29 30 31 32 33